<template>
    <v-container grid-list-xl fluid>
        <loading-component :value="loading"></loading-component>
        <v-layout row wrap>
            <v-flex sm12>
                <v-widget :title="provider + ' Info'">
                    <div slot="widget-content">
                        <v-container>
                            <v-layout row>
                                <v-flex xs2>
                                    ID
                                </v-flex>
                                <v-flex xs4>
                                    {{data.id}}
                                </v-flex>
                                <v-flex xs2>
                                    Approved
                                </v-flex>
                                <v-flex xs4>
                                    {{data.approved_at ? 'Yes' : 'No'}}
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs2>
                                    First Name
                                </v-flex>
                                <v-flex xs4>
                                    {{data.first_name}}
                                </v-flex>
                                <v-flex xs2>
                                    Last Name
                                </v-flex>
                                <v-flex xs4>
                                    {{data.last_name}}
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs2>
                                    Username
                                </v-flex>
                                <v-flex xs4>
                                    {{data.username}}
                                </v-flex>
                                <v-flex xs2>
                                    Status
                                </v-flex>
                                <v-flex xs4 v-if="provider==='Passenger'">
                                    {{data.deleted_at ? 'Archive' : (data.approved_at ? 'Active' : 'Inactive')}}
                                </v-flex>
                                <v-flex xs4 v-else>
                                    {{data.deleted_at ? 'Archive' : data.blacklisted_at ? 'Blacklisted' :
                                    (data.approved_at ? 'Active' : 'Inactive')}}
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs2>
                                    Email
                                </v-flex>
                                <v-flex xs4>
                                    {{data.email}}
                                </v-flex>
                                <v-flex xs6>
                                    <v-form ref="whatsapp_form">
                                        <v-layout row>
                                            <v-flex xs7>
                                                <v-text-field :rules="numberRules" label="Whatsapp(963 required)"
                                                              v-model="new_whatsapp"></v-text-field>
                                            </v-flex>
                                            <v-flex xs5>
                                                <v-btn @click="save" :disabled="new_whatsapp === data.whatsapp_number"
                                                       color="red">Save
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-form>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs2>
                                    Gender
                                </v-flex>
                                <v-flex xs4>
                                    {{data.gender ? 'Male' : 'Female'}}
                                </v-flex>
                                <v-flex xs2>
                                    Birthday
                                </v-flex>
                                <v-flex xs4>
                                    {{birthday}}
                                </v-flex>
                            </v-layout>
                            <div v-if="provider === 'Captain'">
                                <v-layout row>
                                    <v-flex xs2>
                                        Certificate Start
                                    </v-flex>
                                    <v-flex xs4>
                                        {{certificate_start}}
                                    </v-flex>
                                    <v-flex xs2>
                                        Certificate End
                                    </v-flex>
                                    <v-flex xs4>
                                        {{certificate_end}}
                                    </v-flex>
                                </v-layout>
                            </div>
                            <div v-if="provider === 'Captain'">
                                <v-layout row>
                                    <v-flex xs6 v-if="data.id_card_front">
                                        <a target="_blank" :href="api.MAIN_URL + data.id_card_front">ID Card Front</a>
                                    </v-flex>
                                    <v-flex xs6 v-if="data.id_card_back">
                                        <a target="_blank" :href="api.MAIN_URL + data.id_card_back">ID Card Back</a>
                                    </v-flex>
                                    <v-flex xs6>
                                        <a target="_blank" :href="api.MAIN_URL + data.no_conviction">No Conviction</a>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <div v-if="provider === 'Passenger'">
                                <v-layout row>
                                    <v-flex xs6 v-if="data.id_card_front">
                                        <a target="_blank" :href="api.MAIN_URL + data.id_card_front">ID Card Front</a>
                                    </v-flex>
                                    <v-flex xs6 v-if="data.id_card_back">
                                        <a target="_blank" :href="api.MAIN_URL + data.id_card_back">ID Card Back</a>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <slot/>
                        </v-container>
                    </div>
                </v-widget>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import VWidget from "@/components/VWidget";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "data_info",
        components: {LoadingComponent, VWidget},
        props: {
            provider: {
                type: String
            },
            data: {
                type: Object,
                default: () => ({})
            }
        },
        watch: {
            data: {
                handler(val) {
                    this.new_whatsapp = val.whatsapp_number;
                },
                deep: true
            }
        },
        data() {
            return {
                numberRules: [
                    v => !!v || 'Required field'
                ],
                loading: false,
                new_whatsapp: ''
            }
        },
        computed: {
            birthday() {
                return this.moment(this.data.birthday).format('DD MMM YYYY');
            },
            certificate_start() {
                return this.moment(this.data.driving_certificate_start_date).format('DD MMM YYYY');
            },
            certificate_end() {
                return this.moment(this.data.driving_certificate_end_date).format('DD MMM YYYY');
            }
        },
        methods: {
            save() {
                if (!this.$refs.whatsapp_form.validate()) {
                    return;
                }
                this.loading = true;
                const data = {};
                if (this.provider.toLowerCase() === 'captain')
                    data.captain = {
                        whatsapp_number: this.new_whatsapp
                    };
                else
                    data.whatsapp_number = this.new_whatsapp;

                this.axios.put(`${this.provider.toLowerCase()}/${this.data.id}`, data)
                    .then(() => this.data.whatsapp_number = this.new_whatsapp)
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped>

</style>